"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-ignore
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
class ReportController {
    constructor() {
        this.rawReports = [];
        this.rawInitialReports = {
            numPage: -1,
            reports: []
        };
        this.paginatedReports = [];
        this.fetchedPagedReports = [];
        this.filteredReports = [];
        this.itemsPerPageClient = 20;
        this.itemsPerPageServer = 50;
        this.currentPage = 1;
        this.keyToSearch = '';
        this.isLoading = false;
        this.orderDirection = 0;
        this.orderCriteria = '';
    }
    get allReports() {
        return this.rawReports;
    }
    get currentPageReports() {
        if (this.paginatedReports[this.currentPage - 1]) {
            return this.paginatedReports[this.currentPage - 1].reports;
        }
        else {
            return [];
        }
    }
    get orphanReports() {
        return this.rawReports.filter((rep) => rep.parcel === null);
    }
    get ongoingReports() {
        return this.rawReports.filter((rep) => rep.becrop_report !== null);
    }
    allParcels(rawParcelsArray) {
        return rawParcelsArray;
    }
    populateReports(reports) {
        this.rawInitialReports = {
            numPage: 1,
            reports: reports
        };
        this.rawReports = reports;
        this.filterReports();
        this.currentPage = 1;
    }
    filterReports() {
        let tempFiltered = this.rawReports;
        if (this.keyToSearch.length !== 0) {
            tempFiltered = tempFiltered.filter((a) => {
                var _a;
                return a.c_muestra_wineseq
                    .toLowerCase()
                    .includes(this.keyToSearch.trim().toLowerCase()) ||
                    a.client_reference
                        .toLowerCase()
                        .includes(this.keyToSearch.trim().toLowerCase()) ||
                    bmk_ui_framework_1.GlobalFilters.formattedDate(a.fecha_muestra)
                        .toLowerCase()
                        .includes(this.keyToSearch.trim().toLowerCase()) ||
                    ((_a = a.parcel) === null || _a === void 0 ? void 0 : _a.user_name.toLowerCase().includes(this.keyToSearch.trim().toLowerCase()));
            });
        }
        this.filteredReports = tempFiltered;
        this.orderReports();
    }
    get transformOrderCriteria() {
        if (this.orderCriteria === 'id')
            return 'client_reference';
        if (this.orderCriteria === 'parcel')
            return 'parcel';
        if (this.orderCriteria === 'projects/proposal')
            return 'id_proposal';
        if (this.orderCriteria === 'date')
            return 'fecha_muestra';
        return 'client_reference';
    }
    orderReports() {
        if (this.orderCriteria !== '') {
            this.filteredReports = this.filteredReports.sort((a, b) => {
                if (this.orderDirection === -1) {
                    if (this.transformOrderCriteria !== 'parcel') {
                        // return a[this.transformOrderCriteria] > b[this.transformOrderCriteria] ? -1 : 1;
                        return a.client_reference > b.client_reference ? -1 : 1;
                    }
                    else {
                        return a.parcel.user_name > b.parcel.user_name ? -1 : 1;
                    }
                }
                else {
                    if (this.transformOrderCriteria !== 'parcel') {
                        // return a[this.transformOrderCriteria] < b[this.transformOrderCriteria] ? -1 : 1;
                        return a.client_reference < b.client_reference ? -1 : 1;
                    }
                    else {
                        return a.parcel.user_name < b.parcel.user_name ? -1 : 1;
                    }
                }
            });
        }
        else {
            this.filteredReports = this.filteredReports;
        }
        this.paginateReports();
    }
    paginateReports() {
        const numFetchedReports = this.filteredReports.length;
        const numPages = Math.ceil(numFetchedReports / this.itemsPerPageClient);
        const tempPagedReports = Array(numPages).fill('tbd');
        let nextIx = 0;
        const filledPagedReports = tempPagedReports.map((pagRep, i) => {
            const initialIx = nextIx;
            const finalIx = initialIx + this.itemsPerPageClient;
            const newPageRep = {
                numPage: i + 1,
                reports: this.filteredReports.slice(initialIx, finalIx)
            };
            nextIx = finalIx;
            return newPageRep;
        });
        this.paginatedReports = filledPagedReports;
    }
}
exports.default = ReportController;
